import { SORTING_DIR } from "@/common/models";
import { ITableConfig } from "@/components/table/table.model";

// file name, information type , context , topic , sensitivity , source , details
export const table_config: ITableConfig = {
  columns: [
    {
      name: "",
      key: "menu",
      spanMin: "4rem",
      spanMax: "4rem",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: true,
    },
    {
      name: "Report Name",
      key: "name",
      spanMin: "20rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
    },
    {
      name: "Created At",
      key: "date",
      spanMin: "15rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
    },
    {
      name: "Generated By",
      key: "requested_by",
      spanMin: "15rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
    },
    {
      name: "Data Sources",
      key: "data_sources",
      spanMin: "15rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
    },
    {
      name: "Status",
      key: "status",
      spanMin: "15rem",
      spanMax: "1fr",
      sortable: false,
      filterable: false,
      sortDir: SORTING_DIR.ASC,
      isSortActive: false,
    },
  ],
};
